<template>
    
       
        <div>
            <div class="text-left">
                <h3 class="mb-3">{{$t('cal_pivot_PivotPoints')}}</h3>
                <p>{{$t('cal_pivot_point_txt')}}<!--  We know that performing these calculations manually can be a cumbersome process, so you can use this calculator to execute the required calculations quickly and easily. --></p>
            </div>
            <div class="verticallyTab mt-5">
                <p v-if="message != ''" style="color:red">{{message}}</p>
                <div class="bottomTab">
                    <div class="stepForm-contact mt-5">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group field-wrapper">
                                    <input type="text" class="float-field form-control" v-model="H" v-validate="{ required: true,decimal:10}" name="H" :class="{ 'is-invalid': submitted && errors.has('H') }">
                                    <label class="float-label">{{$t('cal_pivot_High')}}</label>
									<p class="error"  v-for="error in errors.collect('H')">{{$t('cal_pivot_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group field-wrapper">
                                    <input  type="text" name="L" class="float-field form-control" v-model="L" v-validate="{ required: true,decimal:10}"  :class="{ 'is-invalid': submitted && errors.has('L') }">
                                    <label class="float-label">{{$t('cal_pivot_Low')}} </label>
									<p class="error"  v-for="error in errors.collect('L')">{{$t('cal_pivot_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group field-wrapper">
                                    <input  type="text" name="O" class="float-field form-control" v-model="O" v-validate="{ required: true,decimal:10}"  :class="{ 'is-invalid': submitted && errors.has('O') }">
                                    <label class="float-label">{{$t('cal_pivot_Open')}}</label>
									<p class="error"  v-for="error in errors.collect('O')">{{$t('cal_pivot_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group field-wrapper">
                                    <input  type="text" name="C" class="float-field form-control" v-model="C" v-validate="{ required: true,decimal:10}"  :class="{ 'is-invalid': submitted && errors.has('C') }">
                                    <label class="float-label">{{$t('cal_pivot_Close')}}</label>
									<p class="error"  v-for="error in errors.collect('C')">{{$t('cal_pivot_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <div class="form-group field-wrapper d-flex align-items-center justify-content-center">
                                    <a href="#" class="common_btn" v-on:click.prevent="getPP()">{{$t('cal_pivot_Calculate_Now')}}</a>
                                    <a href="#" class="Clear ml-4 underline">{{$t('cal_pivot_Clear')}}</a>
                                </div>
                                <div class="table-responsive">
                                    <table class="table commodities-table fundingMethodstable  table-bordered table-striped mb-5">
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>{{$t('cal_pivot_CLASSIC')}}</th>
                                                <th>{{$t('cal_pivot_WOODIE')}}</th>
                                                <th>{{$t('cal_pivot_CAMARILLA')}}</th>
                                                <th>{{$t('cal_pivot_DMARKS')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Resistance')}} 4</td>
                                                <td>{{R4CL}}</td>
                                                <td>{{R4W}}</td>
                                                <td>{{R4C}}</td>
                                                <td>{{R4D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Resistance')}} 3</td>
                                                <td>{{R3CL}}</td>
                                                <td>{{R3W}}</td>
                                                <td>{{R3C}}</td>
                                                <td>{{R3D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Resistance')}} 2</td>
                                                <td>{{R2CL}}</td>
                                                <td>{{R2W}}</td>
                                                <td>{{R2C}}</td>
                                                <td>{{R2D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Resistance')}} 1</td>
                                                <td>{{R1CL}}</td>
                                                <td>{{R1W}}</td>
                                                <td>{{R1C}}</td>
                                                <td>{{R1D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Pivot_Points')}}</td>
                                                <td>{{PCL}}</td>
                                                <td>{{PW}}</td>
                                                <td>{{PC}}</td>
                                                <td>{{PD}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Support')}} 1</td>
                                                <td>{{S1CL}}</td>
                                                <td>{{S1W}}</td>
                                                <td>{{S1C}}</td>
                                                <td>{{S1D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Support')}} 2</td>
                                                <td>{{S2CL}}</td>
                                                <td>{{S2W}}</td>
                                                <td>{{S2C}}</td>
                                                <td>{{S2D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Support')}} 3</td>
                                                <td>{{S3CL}}</td>
                                                <td>{{S3W}}</td>
                                                <td>{{S3C}}</td>
                                                <td>{{S3D}}</td>
                                            </tr>
                                            <tr>
                                                <td align="left">{{$t('cal_pivot_Support')}} 4</td>
                                                <td>{{S4CL}}</td>
                                                <td>{{S4W}}</td>
                                                <td>{{S4C}}</td>
                                                <td>{{S4D}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <ul class="listResult d-flex flex-wrap text-left">
                <li>
                    <p>Segment</p>
                    <h4>0.0</h4>
                </li>
                <li>
                    <p>Account base currency</p>
                    <h4>0.0</h4>
                </li>
                <li>
                    <p>Symbol</p>
                    <h4>EURUSD</h4>
                </li>
                <li>
                    <p>Volume in lots</p>
                    <h4>500</h4>
                </li>
                <li>
                    <p>Current Conversion Price</p>
                    <h4>0.0</h4>
                </li>
            </ul> -->
        </div> 

        
    
</template>
<script>
    export default {
        name: 'pivotpoints',
        data() {
            return {
                H:0,
                O:0,
                L:0,
                C:0,
                R4CL:0,
                R4W:0,
                R4C:0,
                R4D:0,
                R3CL:0,
                R3W:0,
                R3C:0,
                R3D:0,
                R2CL:0,
                R2W:0,
                R2C:0,
                R2D:0,
                R1CL:0,
                R1W:0,
                R1C:0,
                R1D:0,
                PCL:0,
                PW:0,
                PC:0,
                PD:0,
                S4CL:0,
                S4W:0,
                S4C:0,
                S4D:0,
                S3CL:0,
                S3W:0,
                S3C:0,
                S3D:0,
                S2CL:0,
                S2W:0,
                S2C:0,
                S2D:0,
                S1CL:0,
                S1W:0,
                S1C:0,
                S1D:0,
				submitted : false,
				message : ''
            }
        },
        methods:{
            getPP(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						_that.O = parseFloat(_that.O)
						_that.H = parseFloat(_that.H)
						_that.L = parseFloat(_that.L)
						_that.C = parseFloat(_that.C)
						if(_that.H > _that.L){
							let X = 0
							_that.PCL =  parseFloat((_that.H + _that.L + _that.C) / 3)
							_that.PW =   parseFloat((_that.H + _that.L + 2 * _that.C) / 4)
							// _that.PC =   parseFloat((_that.H + _that.L + _that.C) / 3)

							_that.PC =   "-"


							if(_that.C < _that.O){
							X = _that.H + 2 * _that.L + _that.C
							}
							if(_that.C > _that.O){
							X = 2 * _that.H + _that.L + _that.C
							}
							if(_that.C == _that.O){
							X = _that.H + _that.L + 2 * _that.C
							}
							// _that.PD = parseFloat(X)

							_that.PD = "-"
							_that.R4CL = "-"
							_that.R4W = "-"
							_that.R4C = parseFloat((_that.H - _that.L) * 1.1 / 2 + _that.C).toFixed(4)
							_that.R4D = "-"
							_that.R3CL = parseFloat(_that.H + 2 * (_that.PCL - _that.L)).toFixed(4)
							// _that.R3W = parseFloat(_that.H + 2 * (_that.PW - _that.L)).toFixed(4)
							_that.R3W = "-"

							_that.R3C = parseFloat((_that.H - _that.L) * 1.1 / 4 + _that.C).toFixed(4)
							_that.R3D = "-"

							_that.R2CL = parseFloat(_that.PCL + _that.H - _that.L).toFixed(4)

							_that.R2W = parseFloat(_that.PW + _that.H - _that.L).toFixed(4)
							_that.R2C = parseFloat((_that.H - _that.L) * 1.1 / 6 + _that.C).toFixed(4)
							_that.R2D = "-"
							_that.R1CL = parseFloat((2 * _that.PCL) - _that.L).toFixed(4)

							_that.R1W = parseFloat((2 * _that.PW) - _that.L).toFixed(4)
							_that.R1C = parseFloat((_that.H - _that.L) * 1.1 / 12 + _that.C).toFixed(4)
							_that.R1D =  parseFloat(X / 2 - _that.L).toFixed(4)

							_that.S4CL = "-"
							_that.S4W = "-"
							_that.S4C = parseFloat(_that.C - (_that.H - _that.L) * 1.1 / 2).toFixed(4)
							_that.S4D = "-"
							_that.S3CL = parseFloat(_that.L - 2 * (_that.H - _that.PCL)).toFixed(4)
							_that.S3W = "-"
							_that.S3C = parseFloat(_that.C - (_that.H - _that.L) * 1.1 / 4).toFixed(4)
							_that.S3D = "-"
							_that.S2CL = parseFloat(_that.PCL - _that.H + _that.L).toFixed(4)
							_that.S2W = parseFloat(_that.PW - _that.H + _that.L).toFixed(4)
							_that.S2C = parseFloat(_that.C - (_that.H - _that.L) * 1.1 / 6).toFixed(4)
							_that.S2D = "-"
							_that.S1CL = parseFloat((2 * _that.PCL) - _that.H).toFixed(4)
							_that.S1W = parseFloat((2 * _that.PW) - _that.H).toFixed(4)
							_that.S1C = parseFloat(_that.C - (_that.H - _that.L) * 1.1 / 12).toFixed(4)
							_that.S1D =  parseFloat(X / 2 - _that.H).toFixed(4)
						}else{
							_that.message = "Low value should be lower than high value"
						}
					}
				})
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/pivot_points.vue